<template>
  <li class="view-selector" :class="{ active: isActiveView }" @click="$emit('setActiveViewName')">
    {{ view.title | t }}
  </li>
</template>

<script>
export default {
  props: {
    view: {
      type: Object,
      required: true,
    },
    isActiveView: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.view-selector {
  margin: 0 6px 8px 0;
  padding: 12px 20px;
  border: $border-light;
  border-radius: 2px;
  font-size: 14px;
  background-color: $gray-100;
  cursor: pointer;
}

.active {
  height: 56px;
  margin-bottom: 0;
  border-bottom: none;
  border-radius: 2px 2px 0 0;
  font-weight: bold;
  background-color: $white;
}
</style>
